import { AxiosRequestConfig } from 'axios';
import { getDiscoveryConfig } from './configuration';

let HOST = `${window.location.protocol}//${window.location.hostname}:5102`;
let defaultHost = 'api/v1';

getDiscoveryConfig().then(() => {
  const config = localStorage.getItem('config');
  HOST = JSON.parse(config || '').serviceOrderApi;
});

defaultHost = `${HOST}/api/v1`;
export const BASE_URL = localStorage.getItem('config') ? `${JSON.parse(localStorage.getItem('config') || '').serviceOrderApi}/api/v1` : defaultHost;
console.log('BASE_URL api',BASE_URL);
export const axiosConfig: AxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json;',
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-cache',
  },
};
